import styled from 'styled-components';
import { COLORS, pickThemeFontStyles } from '@/theme';
import { Checkbox } from '@/ui';

export const StyledHeader = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 1rem;
`;

export const StyledHeaderText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

export const StyledHeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-left: auto;
`;

export const StyledSavedBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.5rem 0.85rem;
  border-radius: 0.65rem;
  background: rgba(3, 191, 82, 0.12);
  color: ${COLORS.GREEN};
  ${pickThemeFontStyles('14', '20', 'NORMAL')};

  svg {
    width: 1rem;
    height: 1rem;
  }
`;

export const StyledCategoryTitle = styled.div`
  ${pickThemeFontStyles('22', '28', 'SEMI_BOLD')};
  color: ${COLORS.BLACK};
`;

export const StyledSummary = styled.div`
  ${pickThemeFontStyles('14', '20', 'NORMAL')};
  color: ${COLORS.NORMAL_GRAY};
`;

export const StyledGroups = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const StyledGroupCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1.25rem;
  background: ${COLORS.GRAY};
  border-radius: 1rem;
`;

export const StyledGroupHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
`;

export const StyledGroupTitle = styled.span`
  ${pickThemeFontStyles('16', '22', 'SEMI_BOLD')};
  color: ${COLORS.BLACK};
`;

export const StyledGroupCount = styled.span`
  ${pickThemeFontStyles('14', '20', 'NORMAL')};
  color: ${COLORS.NORMAL_GRAY};
`;

export const StyledToggleAll = styled.button`
  margin-left: auto;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  ${pickThemeFontStyles('14', '20', 'NORMAL')};
  color: ${COLORS.BLUE_PRIMARY};

  &:hover {
    text-decoration: underline;
  }

  &:disabled {
    color: ${COLORS.GREY};
    cursor: default;
    text-decoration: none;
  }
`;

export const StyledValues = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
`;

export const StyledValueCheckbox = styled(Checkbox)`
  &&& {
    display: inline-flex;
    align-items: center;
    margin: 0;
    padding: 0.5rem 0.85rem;
    background: ${COLORS.WHITE};
    border: 1px solid ${COLORS.LIGHT_GRAY};
    border-radius: 0.65rem;
    ${pickThemeFontStyles('14', '20', 'NORMAL')};
    transition: background 0.15s ease, border-color 0.15s ease;
  }

  &&&.ant-checkbox-wrapper-checked {
    background: rgba(246, 193, 107, 0.25);
    border-color: ${COLORS.YELLOW};
  }

  &&& .ant-checkbox + span {
    padding-inline-start: 0.5rem;
    color: ${COLORS.BLACK};
  }
`;

export const StyledPlaceholder = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 20rem;
  border-radius: 1rem;
  background: ${COLORS.GRAY};
  ${pickThemeFontStyles('16', '24', 'NORMAL')};
  color: ${COLORS.GREY};
`;
